import React from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { TableContainer, Theme } from "@material-ui/core";
import { DictionaryConfigRowRender } from "./DictionaryConfigRowRender";
import { DictionaryConfigData } from "../../../../types/config";
import { DictionaryConfigRowEdit } from "./DictionaryConfigRowEdit";
import { DictionaryConfigRowDelete } from "./DictionaryConfigRowDelete";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: "100%",
    },
    table: {
      tableLayout: "fixed",
      // tr要素の border プロパティを有効にするため、
      // table要素に collapse を指定する
      borderCollapse: "collapse",
      margin: "0 auto",
      width: "100%",
    },
    tbody: {
      width: "100%",
    },
    th: {
      width: "auto",
      textAlign: "left",
      paddingTop: theme.spacing(0.5),
      paddingRight: theme.spacing(1),
      paddingBottom: theme.spacing(0.5),
      paddingLeft: theme.spacing(1),
    },
    thEditActions: {
      width: "7rem",
      textAlign: "left",
      paddingTop: theme.spacing(0.5),
      paddingRight: theme.spacing(1),
      paddingBottom: theme.spacing(0.5),
      paddingLeft: theme.spacing(1),
    },
    thRenderActions: {
      width: "10rem",
      textAlign: "left",
      paddingTop: theme.spacing(0.5),
      paddingRight: theme.spacing(1),
      paddingBottom: theme.spacing(0.5),
      paddingLeft: theme.spacing(1),
    },
    thSpan: {
      fontSize: "0.7rem",
      fontWeight: "normal",
    },
  })
);

interface Props {
  // キー
  dictKey: string;
  // データ
  data: DictionaryConfigData;
  inputRef: React.RefObject<HTMLInputElement>;
  onChangeFile: (file: File | null) => void;
  // レンダー行アクション
  onEdit: () => any;
  onDelete: () => any;
  // 編集行アクション
  onEditingCanceled: () => any;
  onEditingApproved: () => any;
  // 削除行アクション
  onDeletingCanceled: () => any;
  onDeletingApproved: () => any;
  // エラー
  onError: (error: any) => void;
}

/** 辞書設定テーブル */
export function DictionaryConfigTable(props: Props) {
  const classes = useStyles();

  const {
    // キー
    dictKey,
    // データ
    data,
    inputRef,
    onChangeFile,
    // レンダー行アクション
    onEdit,
    onDelete,
    // 編集行アクション
    onEditingCanceled,
    onEditingApproved,
    // 削除行アクション
    onDeletingCanceled,
    onDeletingApproved,
  } = props;

  // 行コンポーネントを取得する
  const getRowComponent = () => {
    let component = <></>;
    if (data.mode === "render") {
      //
      // 表示行
      //
      component = (
        <DictionaryConfigRowRender
          row={data.row}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      );
    } else if (data.mode === "create" || data.mode === "edit") {
      //
      // 編集行
      //
      component = (
        <DictionaryConfigRowEdit
          // key
          dictKey={dictKey}
          // file
          inputRef={inputRef}
          file={data.file}
          onChangeFile={onChangeFile}
          // action
          onApproved={onEditingApproved}
          onCanceled={onEditingCanceled}
        />
      );
    } else if (data.mode === "delete") {
      //
      // 削除行
      //
      component = (
        <DictionaryConfigRowDelete
          onApproved={onDeletingApproved}
          onCanceled={onDeletingCanceled}
        />
      );
    }
    return component;
  };

  // アクション列クラス取得
  const getThActionsClassName = () => {
    if (data.mode === "render") {
      return classes.thRenderActions;
    }
    return classes.thEditActions;
  };

  //--------------------
  // コンポーネント
  return (
    <TableContainer className={classes.container}>
      <table className={classes.table}>
        <thead>
          <tr>
            <th className={classes.th}>
              <span className={classes.thSpan}>ファイル名</span>
            </th>
            <th className={classes.th}>
              <span className={classes.thSpan}>登録日時</span>
            </th>
            <th className={getThActionsClassName()}>
              <span className={classes.thSpan} />
            </th>
          </tr>
        </thead>
        <tbody className={classes.tbody}>
          {/* 行コンポーネントを取得する */}
          {getRowComponent()}
        </tbody>
      </table>
    </TableContainer>
  );
}
